import TYPES from '../product-types';
import { DIR } from 'core/constants';
import Copy from '@resn/gozer-core/copy';

export default [
    // XS1 SUBSCRIPTIONS

    /**
     *
     * 1 YEAR
     *
     */
    {
        id: 'xs1-sub-flex-yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'FLEX',
        desc: 'One Year Software Subscription',
        term: 1,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flex-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-flex-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/flex-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$39.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },
    {
        id: 'xs1-sub-flow-yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'FLOW',
        desc: 'One Year Software Subscription',
        term: 1,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flow-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-flow-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/flow-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$44.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },
    // !!!!!!!!!!
    // REMOVE!!!!
    // !!!!!!!!!!
    // {
    //     id: 'xs1-sub-form-yearly',
    //     type: TYPES.XS1_SUBSCRIPTION,
    //     title: 'FORM',
    //     desc: 'One Year Software Subscription',
    //     term: 1,
    //     cartTitle: Copy.get('cart-xs1-item-form-subscription-title'),
    //     cartDesc: Copy.get('cart-xs1-item-form-subscription-desc'),
    //     cartImage: `${DIR.IMG}products/cart/form-subscription.png`,
    //     available: true,
    //     priceMonthly: 'CALC', //'$44.99/month',
    //     thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    // },
    // !!!!!!!!!!
    // REMOVE!!!!
    // !!!!!!!!!!
    {
        id: 'xs1-sub-peak-yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'PEAK',
        desc: 'One Year Software Subscription',
        term: 1,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-peak-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-peak-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/peak-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$49.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },

    /**
     *
     * 2 YEAR
     *
     */
    {
        id: 'xs1-sub-flex-2yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'FLEX',
        desc: 'Two Year Software Subscription',
        term: 2,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flex-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-flex-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/flex-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$39.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },
    {
        id: 'xs1-sub-flow-2yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'FLOW',
        desc: 'Two Year Software Subscription',
        term: 2,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flow-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-flow-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/flow-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$44.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },
    {
        id: 'xs1-sub-peak-2yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'PEAK',
        desc: 'Two Year Software Subscription',
        term: 2,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-peak-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-peak-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/peak-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$49.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },

    /**
     *
     * 3 YEAR
     *
     */
    {
        id: 'xs1-sub-flex-3yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'FLEX',
        desc: 'Three Year Software Subscription',
        term: 3,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flex-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-flex-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/flex-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$39.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },
    {
        id: 'xs1-sub-flow-3yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'FLOW',
        desc: 'Three Year Software Subscription',
        term: 3,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flow-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-flow-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/flow-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$44.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },
    {
        id: 'xs1-sub-peak-3yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'PEAK',
        desc: 'Three Year Software Subscription',
        term: 3,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-peak-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-peak-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/peak-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$49.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },

    /**
     *
     * 4 YEAR
     *
     */
    {
        id: 'xs1-sub-flex-4yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'FLEX',
        desc: 'Four Year Software Subscription',
        term: 4,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flex-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-flex-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/flex-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$39.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },
    {
        id: 'xs1-sub-flow-4yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'FLOW',
        desc: 'Four Year Software Subscription',
        term: 4,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-flow-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-flow-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/flow-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$44.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },
    {
        id: 'xs1-sub-peak-4yearly',
        type: TYPES.XS1_SUBSCRIPTION,
        title: 'PEAK',
        desc: 'Four Year Software Subscription',
        term: 4,
        // remove cart
        // cartTitle: Copy.get('cart-xs1-item-peak-subscription-title'),
        // cartDesc: Copy.get('cart-xs1-item-peak-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/peak-subscription.png`,
        available: true,
        priceMonthly: 'CALC', //'$49.99/month',
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },
];
